(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-panel-item"] && !Shopify.designMode) return;
  try {
    function headerSubmenuDuration(details) {
    const value = getComputedStyle(details).getPropertyValue('--header-submenu-duration').trim();
    if (value.endsWith('ms')) return parseFloat(value);
    if (value.endsWith('s')) return parseFloat(value) * 1000;
    return 320;
  }

  function headerSubmenuEase(details) {
    return (
      getComputedStyle(details).getPropertyValue('--header-submenu-ease').trim() ||
      'cubic-bezier(0.32, 0.72, 0, 1)'
    );
  }

  function headerSubmenuReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function headerSubmenuStop(details, panel) {
    const height = panel.getBoundingClientRect().height;
    if (details.headerSubmenuAnimation) {
      details.headerSubmenuAnimation.cancel();
      details.headerSubmenuAnimation = null;
    }
    return height;
  }

  function headerSubmenuSlide(details, panel, from, to, onFinish) {
    const animation = panel.animate([{ height: `${from}px` }, { height: `${to}px` }], {
      duration: headerSubmenuDuration(details),
      easing: headerSubmenuEase(details),
      fill: 'forwards',
    });

    details.headerSubmenuAnimation = animation;

    animation.onfinish = () => {
      if (onFinish) onFinish();
      animation.cancel();
      if (details.headerSubmenuAnimation === animation) {
        details.headerSubmenuAnimation = null;
      }
    };
  }

  function headerSubmenuOpen(details) {
    const panel = details.querySelector('[data-header-submenu-panel]');
    if (!panel) return;

    const from = details.open ? headerSubmenuStop(details, panel) : 0;

    details.removeAttribute('data-closing');
    details.open = true;
    panel.style.marginTop = '12px';

    if (headerSubmenuReducedMotion()) {
      panel.style.height = 'auto';
      return;
    }

    headerSubmenuSlide(details, panel, from, panel.scrollHeight, () => {
      panel.style.height = 'auto';
    });
  }

  function headerSubmenuClose(details) {
    const panel = details.querySelector('[data-header-submenu-panel]');
    if (!panel) return;

    const from = headerSubmenuStop(details, panel);
    details.setAttribute('data-closing', '');

    function settle() {
      details.open = false;
      details.removeAttribute('data-closing');
      panel.style.height = '';
      panel.style.marginTop = '';
    }

    if (headerSubmenuReducedMotion()) {
      settle();
      return;
    }

    headerSubmenuSlide(details, panel, from, 0, settle);
  }

  function bindHeaderSubmenus(root) {
    root.querySelectorAll('.header-panel-item__disclosure').forEach((details) => {
      if (details.dataset.headerSubmenuBound === 'true') return;
      details.dataset.headerSubmenuBound = 'true';

      const summary = details.querySelector('.header-panel-item__summary');
      if (!summary) return;

      summary.addEventListener('click', (event) => {
        event.preventDefault();

        if (details.open && !details.hasAttribute('data-closing')) {
          headerSubmenuClose(details);
          return;
        }

        root.querySelectorAll('.header-panel-item__disclosure[open]').forEach((openItem) => {
          if (openItem === details) return;
          if (openItem.hasAttribute('data-closing')) return;
          headerSubmenuClose(openItem);
        });

        headerSubmenuOpen(details);
      });
    });
  }

  function initHeaderSubmenus() {
    document.querySelectorAll('.header__panel').forEach((panel) => {
      bindHeaderSubmenus(panel);
    });
  }

  initHeaderSubmenus();
  document.addEventListener('shopify:section:load', initHeaderSubmenus);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["share-links"] && !Shopify.designMode) return;
  try {
    /**
   * The clipboard button reports back by swapping its own accessible name and
   * tooltip for two seconds. There is no visible label to change — the row is
   * icon-only — so this is the only channel available, and it works for both a
   * hovering mouse and a screen reader.
   */
  function initShareLinks() {
    document.querySelectorAll('[data-share-links]').forEach(function (root) {
      if (root.dataset.shareLinksReady === 'true') return;
      root.dataset.shareLinksReady = 'true';

      var button = root.querySelector('[data-share-copy]');
      if (!button) return;

      // Without the API there is nothing to copy to, and a button that silently
      // does nothing is worse than one that is not there.
      if (!navigator.clipboard || !navigator.clipboard.writeText) {
        var item = button.parentNode;
        if (item && item.parentNode) item.parentNode.removeChild(item);
        return;
      }

      var label = button.querySelector('[data-share-copy-label]');
      var idleText = label ? label.textContent : '';
      var idleTitle = button.getAttribute('title');
      var copiedText = button.getAttribute('data-copied-label');
      var timer = null;

      button.addEventListener('click', function () {
        navigator.clipboard.writeText(button.getAttribute('data-url')).then(function () {
          if (label) label.textContent = copiedText;
          button.setAttribute('title', copiedText);

          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            if (label) label.textContent = idleText;
            button.setAttribute('title', idleTitle);
          }, 2000);
        });
      });
    });
  }

  initShareLinks();
  document.addEventListener('shopify:section:load', initShareLinks);
  } catch(e) { console.error(e); }
})();

})();
